import { render, staticRenderFns } from "./CurrentStockTabS0100.vue?vue&type=template&id=324a34d0&"
import script from "./CurrentStockTabS0100.vue?vue&type=script&lang=js&"
export * from "./CurrentStockTabS0100.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports